<template>
  <div id="dropdown-v1-ckb2vn">
    <b-form-group id="dropdown-v1-dpt3ob"
      v-if="showType == 'form-builder'"
      :description="properties.description"
      :label="properties.label"
      :style="properties.style"
    >
      <v-select id="dropdown-v1-eif1b2"></v-select>
    </b-form-group>
    <div id="dropdown-v1-wszbgl" v-if="showType == 'properties'"></div>
    <b-form-group id="dropdown-v1-zuq0z2"
      v-if="
        (showType == 'form-submitter' && page == currentPage) ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :description="
        computedConditions.description
          ? computedPropertiesForm.description
          : properties.description
      "
      :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      "
      :style="properties.style"
      :hidden="computedHidden"
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <v-select id="dropdown-v1-1a468d"
        v-model="controlValue"
        :options="computedPropertiesForm.options"
        :multiple="properties.multiselect"
      ></v-select>
    </b-form-group>
    <b-form-group id="dropdown-v1-q7h15u"
      v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      "
      :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      "
    >
      {{ controlValueText }}
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { getComponentBaseId } from "../../../../helpers/formBuilder";
export default {
  name: "DropdownV1",
  props: ["showType", "properties", "form", "id", "results", "page", "componentsIdSuffix"],
  data() {
    return {
      computedProperties: ["description", "label", "hidden", "options"],
      computedConditions: {}
    };
  },
  mounted() {
    if(this.componentsIdSuffix) {
        const baseId = getComponentBaseId(this.id);
        this.initializeComponentValue({
          controlId: baseId,
          properties: this.properties
        });
      }
    this.computeConditions();
  },
  methods: {
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "computeFormSubmitterValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group">
        <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          ${this.controlValue ? this.controlValue : ""}
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors,
      currentPage: state => state.form.currentPage
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    controlValue: {
      get() {
        const baseId = getComponentBaseId(this.id);
        if (this.results) return this.results[baseId];
        return this.getFormSubmitterComponentValue(baseId);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          const baseId = getComponentBaseId(this.id);
          this.setFormSubmitterComponentValue({
            controlId: baseId,
            controlValue: newControlValue,
            userAction: true
          });
          this.$emit("update-child-control-value", {
            controlId: baseId,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    controlValueText() {
      return this.controlValue && Array.isArray(this.controlValue)
        ? this.controlValue.join(", ")
        : "";
    },
    errors: {
      get() {
        const errorId = getComponentBaseId(this.id, this.formErrors);
        return this.formErrors[errorId] ? this.formErrors[errorId] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>
